import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MobileDetectorService } from 'src/app/services/mobileDetector/mobile-detector.service';

@Component({
  selector: 'app-admin-feedback',
  templateUrl: './admin-feedback.component.html',
  styleUrls: ['./admin-feedback.component.scss']
})
export class AdminFeedbackComponent implements OnInit {

  isMobile: boolean = false;
  fechaFeedback: string = ""
  alumnoId: number = 0;

  constructor(
    private mobileDetectorService: MobileDetectorService,
    private router: Router
  ) { }


  ngOnInit(): void {

    this.isMobile = this.mobileDetectorService.isMobile();
    sessionStorage.setItem('active','alumnos');
    this.alumnoId = parseInt(sessionStorage.getItem('id_usuario'),10);
  }

  navigate() {
    this.router.navigate(['/admin/alumnos']);
  }

}
